type Props = {
  width?: number;
  height?: number;
  fill?: string;
  stroke?: string;
  className?: string;
};

export function SparklesIcon(props: Props) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 19 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        width: props.width ?? 24,
        height: props.height ?? 24,
      }}
      className={props.className}
    >
      <path
        d="M16.2398 5.3376C16.3263 4.88356 16.5315 4.46859 16.8294 4.14506C17.1272 3.82155 17.5043 3.60425 17.9129 3.5207L19.0005 3.2987L17.9128 3.0767H17.9129C17.5043 2.99313 17.1272 2.77585 16.8294 2.45234C16.5315 2.12884 16.3264 1.71385 16.2398 1.2598L16.0005 0L15.7612 1.2598C15.6746 1.71385 15.4695 2.12881 15.1716 2.45234C14.8738 2.77585 14.4967 2.99315 14.0881 3.0767L13.0005 3.2987L14.0882 3.5207H14.0881C14.4966 3.60427 14.8738 3.82155 15.1716 4.14506C15.4695 4.46857 15.6746 4.88356 15.7611 5.3376L16.0005 6.5974L16.2398 5.3376Z"
        fill={props.fill ?? '#593B37'}
      />
      <path
        d="M7.69343 12.6768C7.8989 11.5984 8.3861 10.6129 9.09361 9.84452C9.80089 9.07619 10.6966 8.5601 11.6669 8.36166L14.25 7.83442L11.6667 7.30717H11.6669C10.6967 7.10869 9.80095 6.59265 9.09366 5.82432C8.38615 5.05599 7.89897 4.07039 7.69348 2.99202L7.12502 0L6.55657 2.99202C6.3511 4.07039 5.8639 5.05592 5.15639 5.82432C4.4491 6.59265 3.55339 7.10873 2.5831 7.30717L0 7.83442L2.58327 8.36166H2.58305C3.55334 8.56014 4.44905 9.07619 5.15634 9.84452C5.86385 10.6128 6.35103 11.5984 6.55652 12.6768L7.12497 15.6688L7.69343 12.6768Z"
        fill={props.fill ?? '#593B37'}
      />
    </svg>
  );
}
